// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeepLinkView__footer-d5da5b {
  padding: 0 32px 32px;
}`, "",{"version":3,"sources":["webpack://./src/pages/deepLink/DeepLinkView/DeepLinkView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF","sourcesContent":[".footer {\n  padding: 0 32px 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `DeepLinkView__footer-d5da5b`
};
module.exports = ___CSS_LOADER_EXPORT___;
